import { Container, Typography, useTheme } from "@mui/material";
import { PaymentIcons } from "../payment-icons/index.js";
import { useMediaQuery } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const FooterPaymentsNotice = (containerProps) => {
    const theme = useTheme();
    const isAtleastLg = useMediaQuery(theme.breakpoints.up("lg"));
    const { t } = useTranslation("c-footer");
    return (React.createElement(Container, { maxWidth: "xl", ...containerProps },
        React.createElement(Typography, { textAlign: "center", component: "div", variant: "h5", sx: { width: "100%", pb: { xs: 2, lg: 3 } } }, t("payment-headline", "Sicher bezahlen")),
        React.createElement(Typography, { textAlign: "center", variant: isAtleastLg ? "body1" : "body2", sx: { pb: 3, margin: "0 auto", maxWidth: "68ch" } }, t("payment-copy", "Unsere Seite ist kompatibel mit gängigen modernen Zahlungsdienstleistern. Wir verwenden SSL für sichere Transaktionen.")),
        React.createElement(PaymentIcons, { sx: { maxWidth: { xs: "300px", sm: "280px", lg: "320px" }, margin: "0 auto" } })));
};
//# sourceMappingURL=payments-info.js.map